// Catálogo de roles para la UI: etiquetas legibles (en español) y qué roles se
// pueden ASIGNAR al crear/editar un usuario. Los valores técnicos (enum RolPerfil)
// siguen yendo a la BD tal cual; aquí solo se controla su presentación.

// Etiqueta legible por rol (cubre TODOS los valores del enum, incluidos los que ya
// no se asignan, para mostrarlos bien si un usuario existente los tiene).
export const ROLES_LABEL: Record<string, string> = {
  DIRECTOR_INSTRUCCION: 'Director de Instrucción',
  DIRECTOR_JUZGAMIENTO: 'Director de Juzgamiento',
  DIRECTOR_SEGUNDA_INSTANCIA: 'Director de Segunda Instancia',
  FUNCIONARIO_INSTRUCCION: 'Funcionario de Instrucción',
  CONTRATISTA_INSTRUCCION: 'Contratista de Instrucción',
  FUNCIONARIO_JUZGAMIENTO: 'Funcionario de Juzgamiento',
  CONTRATISTA_JUZGAMIENTO: 'Contratista de Juzgamiento',
  TECNICO_ADMINISTRATIVO: 'Técnico administrativo',
  TECNOLOGO_APOYO: 'Tecnólogo de apoyo',
  ABOGADO_ESPECIALIZADO: 'Abogado especializado',
  SECRETARIA: 'Secretaría',
  SECRETARIA_JURIDICA: 'Secretaría Jurídica',
  SEGUNDA_INSTANCIA: 'Segunda instancia (Gobernador)',
  SUPERVISOR: 'Supervisor',
  APOYO_SUPERVISOR: 'Apoyo al supervisor',
  DEFENSOR: 'Defensor',
  DISCIPLINADO: 'Disciplinado',
  QUEJOSO: 'Quejoso',
  ADMINISTRADOR: 'Administrador',
};

/** Convierte un valor de enum en etiqueta legible (con respaldo genérico). */
export function labelRol(v?: string | null): string {
  if (!v) return '—';
  if (ROLES_LABEL[v]) return ROLES_LABEL[v];
  // Respaldo: MAYUS_CON_GUION → "Mayus con guion"
  const s = v.replace(/_/g, ' ').toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// Roles que un administrador PUEDE asignar al crear/editar un usuario.
// (Quejoso, Disciplinado y Defensor nacen en el portal, no se crean aquí;
//  Secretaría y Director de Segunda Instancia se retiraron del modelo.)
export const ROLES_SELECCIONABLES: string[] = [
  'DIRECTOR_INSTRUCCION',
  'DIRECTOR_JUZGAMIENTO',
  'FUNCIONARIO_INSTRUCCION',
  'CONTRATISTA_INSTRUCCION',
  'FUNCIONARIO_JUZGAMIENTO',
  'CONTRATISTA_JUZGAMIENTO',
  'TECNICO_ADMINISTRATIVO',
  'TECNOLOGO_APOYO',
  'ABOGADO_ESPECIALIZADO',
  'SECRETARIA_JURIDICA',
  'SEGUNDA_INSTANCIA',
  'SUPERVISOR',
  'APOYO_SUPERVISOR',
  'ADMINISTRADOR',
];
